import React, { Fragment, useMemo } from 'react';
import { FormControl, FormControlLabel, FormHelperText, Grid, Radio, RadioGroup } from '@material-ui/core';
import { FormGridType } from '@sierralabs/forms-core';
import { useDataSourceProps } from '../hooks/form/useDataSourceProps';
import { useFormGridConfig } from '../Form.hooks';
import { useFormContext } from '../FormContext';
export const FormRadioGroup = ({ element, edit, disabled, value, onChange }) => {
    const { formValues, setFormValue, elementPlugins, entitySchema } = useFormContext();
    const plugin = elementPlugins.find(p => p.type === element.type);
    const { grid, row, gridColumns } = useFormGridConfig(element.config);
    const options = useMemo(() => {
        var _a;
        return (((_a = element.config) === null || _a === void 0 ? void 0 : _a.options) || []).map(o => ['string', 'number', 'boolean'].includes(typeof o)
            ? { value: o, label: o.toString() }
            : o);
    }, [element.config]);
    const key = element.dataSource || element.key;
    if (typeof value === 'undefined') {
        value =
            typeof formValues[key] === 'undefined' ? '' : formValues[key];
    }
    const dataSourceProps = useDataSourceProps(element, value);
    return (React.createElement(FormControl
    // name={name}
    // error={meta.touched && Boolean(meta.error)}
    , { 
        // name={name}
        // error={meta.touched && Boolean(meta.error)}
        component: 'fieldset', fullWidth: true },
        React.createElement(RadioGroup, { row: row, "aria-label": element.title, value: typeof value === 'number' ? value.toString() : value, onChange: event => {
                let value = event.target.value;
                if ((plugin === null || plugin === void 0 ? void 0 : plugin.type) === 'Boolean') {
                    value = value === 'true';
                }
                onChange === null || onChange === void 0 ? void 0 : onChange(event, value);
                if (event.isPropagationStopped() || event.isDefaultPrevented()) {
                    return;
                }
                const column = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns.find(c => c.name === element.dataSource);
                if ((column === null || column === void 0 ? void 0 : column.type) === 'integer' || (column === null || column === void 0 ? void 0 : column.type) === 'numeric') {
                    setFormValue(key, Number(value), element);
                }
                else {
                    setFormValue(key, value);
                }
            } }, options.map((option, index) => {
            const radio = (React.createElement(FormControlLabel, { disabled: edit || disabled, label: option.label, value: option.value, control: React.createElement(Radio, { color: 'primary' }) }));
            if (grid !== FormGridType.Grid) {
                return React.createElement(Fragment, { key: index }, radio);
            }
            return (React.createElement(Grid, { key: index, item: true, xs: 6, md: (12 / gridColumns) }, radio));
        })),
        dataSourceProps.helperText && (React.createElement(FormHelperText, { error: dataSourceProps.error }, dataSourceProps.helperText))));
};
export default FormRadioGroup;
//# sourceMappingURL=FormRadioGroup.js.map